export default __webpack_public_path__ + "static/media/multisearch_dark.ffcd973f.svg";